<template>
  <div>
    <div class="imgList">
      <div
        v-for="(item, i) in materialNum == 1 ? isList : imgList"
        :key="`${item[prop.id] || item[prop.img]}-${i}`"
        :style="{ width: width, height: width, lineHeight: width }"
        :class="['load-block', { avtice: item }]"
      >
        <img
          class="img"
          :src="resolveImageDisplayUrl(item[prop.img])"
          alt=""
          srcset=""
        >
        <div class="boxDel">
          <el-icon
            class="icon viewIcon"
            @click.stop="lookFn(item)"
          >
            <View />
          </el-icon>
          <el-icon
            v-show="!disabled"
            class="icon"
            @click.stop="delFn(i)"
          >
            <Delete />
          </el-icon>
        </div>
      </div>
      <div
        v-show="imgList.length < materialNum && !valueImg && !disabled"
        :style="{ width: width, height: width, lineHeight: width }"
        :class="['load-block']"
        @click="isdialogVisibleFn()"
      >
        <img
          v-show="valueImg"
          class="img"
          :src="resolveImageDisplayUrl(valueImg)"
          alt=""
          srcset=""
        >
        <el-icon><Plus /></el-icon>
      </div>
    </div>
    <el-dialog
      v-model="dialogVisible"
      title="Tips"
      :before-close="handleClose"
      append-to-body
      width="1280"
    >
      <template #header>
        <div class="brandMaterial">
          <brandMaterial
            ref="brandMaterialRef"
            :prop="prop"
            :check-list="imgList"
            :material-num="materialNum"
            :path-type="2"
            @on-check="onImageFn"
          />
        </div>
      </template>
    </el-dialog>
    <ImageFullScreen
      :is-full-screen="isFullScreen"
      :image="currentImageUrl"
      @is-full-screen-fn="isFullScreenFn"
    />
  </div>
</template>
<!-- eslint-disable-next-line vue/block-lang -- 旧组件保留 JavaScript，避免仅为规则迁移脚本语言 -->
<script setup>
import { nextTick, watch } from 'vue';
import { resolveImageDisplayUrl } from '@/utils/image';
import brandMaterial from '@/views/brand/brandMaterial.vue';
const dialogVisible = ref(false);
import ImageFullScreen from '@/components/ImagePreview/ImageFullScreen.vue';
const currentImageUrl = ref('');
const isFullScreen = ref(false);
const brandMaterialRef = ref(null);
const emits = defineEmits(['update:imgList', 'update:valueImg', 'onCheck', 'del']);
const isList = ref([]);
const props = defineProps({
  valueImg: {
    // 单选
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '60px',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  materialNum: {
    type: Number,
    default: 1,
  },
  prop: {
    type: Object,
    default: () => {
      return { img: 'img', id: 'id' };
    },
  },
  imgList: {
    // 多选
    type: Array,
    default: () => [],
  },
});
watch(
  () => props.valueImg,
  (val) => {
    console.log('val------', val);
    if (val) {
      isList.value = [
        {
          [props.prop.img]: val,
          id: '',
        },
      ];
    } else {
      isList.value = [];
    }
    console.log(' props.imgList-------', isList.value);
  },
  { immediate: true },
);

const isdialogVisibleFn = () => {
  if (props.disabled) return;
  dialogVisible.value = true;
  nextTick(() => {
    brandMaterialRef.value.oncheckList();
  });
};
const onImageFn = (data) => {
  if (props.materialNum == 1) {
    // 单选

    emits('onCheck', data);
  } else {
    // 多选
    const arrImgList = [];
    data.forEach((v) => {
      arrImgList.push({
        [props.prop.img]: v.path,
        [props.prop.id]: v.materialId,
      });
      emits('update:imgList', arrImgList);
    });
  }
  dialogVisible.value = false;
};
const delFn = (i) => {
  console.log('删除');
  if (props.materialNum == 1) {
    // 单选
    dialogVisible.value = false;
    emits('del');
  } else {
    // 多选
    const arrImgList = props.imgList;
    arrImgList.splice(i, 1);
    emits('update:imgList', arrImgList);
  }
};
const lookFn = (item) => {
  // 预览只使用完整展示地址，不改变父组件保存的原始路径。
  currentImageUrl.value = resolveImageDisplayUrl(item[props.prop.img]);
  isFullScreen.value = true;
};
function isFullScreenFn() {
  isFullScreen.value = false;
}
</script>
<style lang="scss" scoped>
.imgList {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.load-block {
  background: #fafafa;
  border-radius: 8px;
  overflow: hidden;
  text-align: center;
  font-size: 22px;
  color: #777;
  position: relative;
  border: #d8d4d4 1px dashed;
  .boxDel {
    display: none;
  }
  &.avtice {
    border: none;
    &:hover {
      .boxDel {
        position: absolute;
        width: 100%;
        height: 100%;
        right: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.3); /* 半透明黑遮罩 */
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.3s ease;
        cursor: auto;
        color: #fff;
        font-size: 14px;
        .icon {
          &:hover {
            font-size: 16px;
          }
          margin-inline-start: 10px;
        }
        .viewIcon {
          margin-inline-start: 0px;
          cursor: pointer;
        }
      }
    }
  }

  .img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
